import { useQuery } from "@tanstack/react-query";
import { Tooltip } from "antd";
import React from "react";
import { GrCloudDownload } from "react-icons/gr";
import { IoCloseOutline } from "react-icons/io5";
import { MdOutlineCheck } from "react-icons/md";
import {
  getEachCellStatus,
  getProjectWiseUploadedListAllBucketPath,
  userEmail,
} from "../../../api/apiCallManager";
import WrapperLoader from "../../../components/spinner/WrapperLoader";
import AccessTo from "../../../components/is-show/AccessTo";
import { CM, FL, PA } from "../../router/AddRoutesJson";
import FinalModelViewJson from "./FinalModelViewJson";

function FinalModelDownloadCell({ rowItems }) {
  // const {
  //   data: uploadedListData,
  //   error: uploadedListError,
  //   isLoading: isUploadedListLoading,
  // } = useQuery({
  //   queryKey: [
  //     "getProjectWiseUploadedListAllBucketPath_final_model_qc_View_json",
  //     rowItems?.siteManager?.email,
  //   ],
  //   queryFn: () => getProjectWiseUploadedListAllBucketPath(),
  //   enabled: Boolean(rowItems?.siteManager?.email),
  // });

  // let filteredFiles =
  //   uploadedListData?.filter(
  //     (file) => file?.siteName === rowItems?.siteManager?.siteName
  //   ) || [];

  // // Safely check if filteredFiles has a valid value
  // const shouldFetch =
  //   filteredFiles.length > 0 &&
  //   filteredFiles[0]?.bucketName &&
  //   rowItems?.infra?.[0];

  // const {
  //   data: InitialDataScriptStatus,
  //   error,
  //   isLoading,
  // } = useQuery({
  //   queryKey: [
  //     "getEachCellStatus_transformation_data_qc_all_status__final_model_qc__",
  //     filteredFiles?.[0]?.bucketPath,
  //   ],
  //   queryFn: () =>
  //     getEachCellStatus(rowItems, filteredFiles, "final_model_status"),
  //   enabled: Boolean(shouldFetch),
  // });

  return (
    <div className="flex justify-center">
      {/* {JSON.stringify(rowItems, null, 4)} */}

      <AccessTo
        role={[FL, PA, CM]}
        fallBackComponent={
          <Tooltip title="Final Data QC Completed">
            <MdOutlineCheck color="green" size={16} />
          </Tooltip>
        }
      >
        {/* {rowItems?.clientManager == userEmail)} */}
        <FinalModelViewJson rowItems={rowItems} />
      </AccessTo>
    </div>
  );
}

export default FinalModelDownloadCell;
